import { SVGProps } from 'react';

const ArrowUpFromLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m6 9 6-6 6 6m-6-6v14m-7 4h14"
    />
  </svg>
);
export default ArrowUpFromLine;
